var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-columns',{attrs:{"is-multiline":""}},[_c('b-column',{staticClass:"is-full"},[_c(_vm.getComponentByAgentType,{tag:"component"})],1),_c('b-column',{staticClass:"is-full"},[_c('agent-synonyms')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }